import theme from '../../styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    alignSelf: 'flex-start',
    width: '100%'
  },

  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: theme.spacing(4),
    paddingRight: theme.spacing(4)
  },

  headerContentLeft: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%'
  },

  headerContentRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  },

  title: (headerAlignment: 'left' | 'center') => ({
    marginBottom: theme.spacing(1),
    fontSize: '48px',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px'
    },
    textAlign: headerAlignment
  }),

  subtitle: (headerAlignment: 'left' | 'center') => ({
    color: theme.palette.text.secondary,
    fontSize: '24px',
    marginBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4)
    },
    textAlign: headerAlignment
  }),

  loaderContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },

  dealsContainer: {
    width: '100%'
  }
}

export default styles
